import { render, staticRenderFns } from "./ErrorRoute.vue?vue&type=template&id=18b1ed5c&"
import script from "./ErrorRoute.vue?vue&type=script&lang=js&"
export * from "./ErrorRoute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports